var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StackChart',{ref:"chart",attrs:{"unit":_vm.unit,"scale":_vm.scale,"title":_vm.title,"loading":_vm.loading,"daterange":_vm.daterange}})
}
var staticRenderFns = []

export { render, staticRenderFns }